import { Images } from '@/assets/images';
import { DocTypeEnum } from '@/constant';
import { dayjs, formatDate } from '@/utils';

import { isNotNilOrEmpty } from 'ramda-adjunct';
import * as Yup from 'yup';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	organizationName: '',
	foreignCountryName: '',
	workerName: '',
	workerSignature: '',
	passportNumber: '',
	writeDate: '',
	// Checklist items (17 items - Yes/No for each)
	checklist1: 'O',
	checklist2: 'O',
	checklist3: 'O',
	checklist4: 'O',
	checklist5: 'O',
	checklist6: 'O',
	checklist7: 'O',
	checklist8: 'O',
	checklist9: 'O',
	checklist10: 'O',
	checklist11: 'O',
	checklist12: 'O',
	checklist13: 'O',
	checklist14: 'O',
	checklist15: 'O',
	checklist16: 'O',
	checklist17: 'O',
};

type IValues = typeof initializeValue;

const YES_NO_OPTIONS = ['O', 'X']; // O for Yes, X for No

export const AGRICULTURAL_WORKPLACE_SAFETY_CHECKLIST_FOR_WORKERS_CONFIG: FormConfig<
	IValues,
	DocTypeEnum.ARF_10
> = {
	initializeValue,
	title: '농업 안전관리 체크리스트[근로자용]',
	mapPropToValues({ applicantData, detailData, unitData }) {
		return {
			organizationName: detailData?.unitInfo?.name || unitData?.name || '',
			foreignCountryName: applicantData?.nationalName || '',
			workerName: applicantData?.fullName || '',
			passportNumber: applicantData?.passportNo || '',
			writeDate: formatDate(dayjs()),
		};
	},
	pages: [
		{
			background: {
				src: Images.formAgriculturalWorkplaceSafetyChecklistForWorkers,
				className: 'template',
				dataSource: Images.formAgriculturalWorkplaceSafetyChecklistForWorkers,
			},
			textAreas: [
				(values, index) => ({
					name: 'organizationName',
					maxHeight: 26,
					maxLength: 20,
					containerClassName: 'absolute top-[167px] left-[222px] w-[186px]',
					className: 'text-[13px] leading-[13px]',
				}),
				(values, index) => ({
					name: 'foreignCountryName',
					maxHeight: 26,
					maxLength: 30,
					containerClassName: 'absolute top-[167px] left-[520px] w-[190px]',
					className: 'text-[13px] leading-[13px]',
				}),
				(values, index) => ({
					name: 'workerName',
					maxHeight: 26,
					maxLength: 38,
					containerClassName: 'absolute top-[192px] left-[175px] w-[230px]',
					className: 'text-[13px] leading-[13px]',
				}),
				(values, index) => ({
					name: 'passportNumber',
					maxHeight: 26,
					maxLength: 20,
					containerClassName: 'absolute top-[218px] left-[175px] w-[230px]',
					className: 'text-[13px]',
				}),
			],
			checkboxes: [
				// Checklist item 1
				{
					name: 'checklist1',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[318px] right-[157px] w-6 h-6', // Yes (O)
						'absolute top-[318px] right-[100px] w-6 h-6', // No (X)
					],
					iconType: 'circle',
				},
				// Checklist item 2
				{
					name: 'checklist2',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[370px] right-[157px] w-6 h-6',
						'absolute top-[370px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 3
				{
					name: 'checklist3',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[427px] right-[157px] w-6 h-6',
						'absolute top-[427px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 4
				{
					name: 'checklist4',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[463px] right-[157px] w-6 h-6',
						'absolute top-[463px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 5
				{
					name: 'checklist5',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[503px] right-[157px] w-6 h-6',
						'absolute top-[503px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 6
				{
					name: 'checklist6',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[540px] right-[157px] w-6 h-6',
						'absolute top-[540px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 7
				{
					name: 'checklist7',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[579px] right-[157px] w-6 h-6',
						'absolute top-[579px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 8
				{
					name: 'checklist8',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[610px] right-[157px] w-6 h-6',
						'absolute top-[610px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 9
				{
					name: 'checklist9',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[638px] right-[157px] w-6 h-6',
						'absolute top-[638px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 10
				{
					name: 'checklist10',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[679px] right-[157px] w-6 h-6',
						'absolute top-[679px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 11
				{
					name: 'checklist11',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[722px] right-[157px] w-6 h-6',
						'absolute top-[722px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 12
				{
					name: 'checklist12',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[763px] right-[157px] w-6 h-6',
						'absolute top-[763px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 13
				{
					name: 'checklist13',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[802px] right-[157px] w-6 h-6',
						'absolute top-[802px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 14
				{
					name: 'checklist14',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[843px] right-[157px] w-6 h-6',
						'absolute top-[843px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 15
				{
					name: 'checklist15',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[883px] right-[157px] w-6 h-6',
						'absolute top-[883px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 16
				{
					name: 'checklist16',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[931px] right-[157px] w-6 h-6',
						'absolute top-[931px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 17
				{
					name: 'checklist17',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[977px] right-[157px] w-6 h-6',
						'absolute top-[977px] right-[100px] w-6 h-6',
					],
					iconType: 'circle',
				},
			],
			signatures: [
				{
					name: 'workerSignature',
					className: 'absolute top-[198px] left-[466px] w-[244px] h-[46px]',
				},
			],
			datePickers: [
				{
					name: 'writeDate',
					segmentedInputs: true,
					format: 'YYYY            MM         DD',
					containerClassName: 'absolute top-[246px] left-[370px]',
					style: { fontSize: '14px' },
				},
			],
			highlightBoxes: [
				{
					name: 'organizationName',
					className: 'absolute top-[167px] left-[222px] w-[186px]',
				},
				{
					name: 'foreignCountryName',
					className: 'absolute top-[167px] left-[520px] w-[190px]',
				},
				{
					name: 'workerName',
					className: 'absolute top-[192px] left-[175px] w-[230px]',
				},
				{
					name: 'passportNumber',
					className: 'absolute top-[218px] left-[175px] w-[230px]',
				},
				{
					name: 'writeDate',
					className: 'absolute top-[246px] left-[370px] w-[158px]',
				},
				{
					name: 'workerSignature',
					className: 'absolute top-[198px] left-[466px] w-[244px] !h-[46px]',
				},
				{
					names: [
						'checklist1',
						'checklist2',
						'checklist3',
						'checklist4',
						'checklist5',
						'checklist6',
						'checklist7',
						'checklist8',
						'checklist9',
						'checklist10',
						'checklist11',
						'checklist12',
						'checklist13',
						'checklist14',
						'checklist15',
						'checklist16',
						'checklist17',
					],
					requireAllNames: true,
					className: 'absolute top-[278px] left-[597px] w-[113px] !h-[31px]',
				},
			],
		},
	],
	validationSchema: Yup.object()
		.shape({
			checklist1: Yup.string().required(),
			checklist2: Yup.string().required(),
			checklist3: Yup.string().required(),
			checklist4: Yup.string().required(),
			checklist5: Yup.string().required(),
			checklist6: Yup.string().required(),
			checklist7: Yup.string().required(),
			checklist8: Yup.string().required(),
			checklist9: Yup.string().required(),
			checklist10: Yup.string().required(),
			checklist11: Yup.string().required(),
			checklist12: Yup.string().required(),
			checklist13: Yup.string().required(),
			checklist14: Yup.string().required(),
			checklist15: Yup.string().required(),
			checklist16: Yup.string().required(),
			checklist17: Yup.string().required(),
			organizationName: Yup.string().required(),
			foreignCountryName: Yup.string().required(),
			workerName: Yup.string().required(),
			workerSignature: Yup.string().required(),
			passportNumber: Yup.string().required(),
			writeDate: Yup.string().required(),
		})
		.test(
			'at-least-one-field',
			'At least one field must have data',
			function (value) {
				const fields = [
					'checklist1',
					'checklist2',
					'checklist3',
					'checklist4',
					'checklist5',
					'checklist6',
					'checklist7',
					'checklist8',
					'checklist9',
					'checklist10',
					'checklist11',
					'checklist12',
					'checklist13',
					'checklist14',
					'checklist15',
					'checklist16',
					'checklist17',
				];

				return fields.some((field) =>
					// @ts-expect-error: ignore here
					isNotNilOrEmpty(value[field])
				);
			}
		),
};
